export function weekDaysSorter(array, key) {
  const sorter = {
    // SUN: 0, // << if sunday is first day of week
    MON: 1,
    TUE: 2,
    WED: 3,
    THU: 4,
    FRI: 5,
    SAT: 6,
    SUN: 7,
  };

  return array.sort((a, b) => {
    const day1 = a[key].toUpperCase();
    const day2 = b[key].toUpperCase();
    return sorter[day1] - sorter[day2];
  });
}
